import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  SORT_DEFAULT,
  SORT_OPTIONS
} from 'dpl/puppy_search_results/utils/constants';
import FancyDropdown, {
  FancyDropdownMenu,
  FancyDropdownMenuItem,
  FancyDropdownToggle
} from 'dpl/components/FancyDropdown';
import Icon from 'dpl/common/components/Icon';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import { PAGE, SORT } from 'dpl/constants/query_params';

function getSortOptionTitle(value) {
  const [defaultOption] = SORT_OPTIONS;
  const option = SORT_OPTIONS.find(o => o.value === value) ?? defaultOption;
  return option.title;
}

export default function SortDropdown({ className }) {
  const sortParam = useSelector(({ queryParams }) => queryParams[SORT]);
  const [selectedSortOption, setSelectedSortOption] = useState(
    sortParam || SORT_DEFAULT
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setSelectedSortOption(sortParam);
  }, [sortParam]);

  function toggleSort(value) {
    setSelectedSortOption(value);
    if (value === SORT_DEFAULT) {
      dispatch(resetParams(SORT, { hash: true }));
    } else {
      dispatch(
        pushParams(
          {
            [SORT]: value
          },
          { hash: true }
        )
      );
    }

    dispatch(resetParams(PAGE));
  }

  return (
    <div
      className={classnames('PuppySearchResultsSortDropdown w-100', className)}
    >
      <FancyDropdown isOpen={isDropdownOpen} onChange={setIsDropdownOpen}>
        <FancyDropdownToggle>
          <div className="w-100 ba b--light-gray br3 pv3 ph3 flex justify-between align-items-center">
            <p className="truncate">
              Sort by: {getSortOptionTitle(selectedSortOption)}
            </p>
            <Icon
              name={`fat-arrow-${isDropdownOpen ? 'up' : 'down'}`}
              width="20px"
              height="20px"
            />
          </div>
        </FancyDropdownToggle>
        <FancyDropdownMenu className="overflow-y-auto ba b--silver br3 fw-normal">
          {SORT_OPTIONS.map((option, idx) => {
            const isSelected = selectedSortOption === option.value;
            return (
              <FancyDropdownMenuItem
                key={idx}
                itemKey={idx}
                className="flex items-center"
              >
                {isSelected && (
                  <Icon name="checkmark" width="20px" height="20px" />
                )}
                <button
                  data-test-id={`sort_option_${idx}`}
                  type="button"
                  onClick={() => toggleSort(option.value)}
                  className={classnames('pv2 ph2 w-100', {
                    ml5: !isSelected
                  })}
                >
                  {option.title}
                </button>
              </FancyDropdownMenuItem>
            );
          })}
        </FancyDropdownMenu>
      </FancyDropdown>
    </div>
  );
}

SortDropdown.propTypes = {
  className: PropTypes.string
};

SortDropdown.defaultProps = {
  className: null
};
